import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t, isMobile, throttle } from '@insight/toolkit-utils';
import Button from '../Button/Button';
import { ProductDetailTabResource } from './ProductDetailTabResource';

export const ProductDetailTabProtection = ({
  limit,
  disableNavLinks,
  protection,
  thirdPartyProtection,
  addToCart,
  showPrice,
  categoryType,
}) => {
  const [showMore, setShowMore] = useState(false);
  const [showOtherMore, setShowOtherMore] = useState(false);

  // Used to limit results to 3 plans on mobile
  const [isOnMobile, setIsOnMobile] = useState(isMobile());
  useEffect(() => {
    const onResize = throttle(() => {
      setIsOnMobile(isMobile());
    }, 250);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const renderPlans = (warranties, isOEM) => {
    const showFlag = isOEM ? showMore : showOtherMore;
    const setShowFlag = isOEM ? setShowMore : setShowOtherMore;

    if (!warranties.length) {
      return null;
    }
    // Check and update limit based on screen size
    let length = isOnMobile ? 3 : limit;
    if (showFlag) {
      length = warranties.length;
    }

    const visiblePlans = warranties.slice(0, length);
    return (
      <div className="c-product-tabs__section">
        <h5 className="u-text-bold">
          {t(isOEM ? 'Manufacturer warranties' : 'Other protection options')}
        </h5>
        {visiblePlans.map((plan) => (
          <ProductDetailTabResource
            key={plan.materialId}
            materialId={plan.materialId}
            partNumber={plan.manufacturerPartNumber}
            shortDescription={plan.name}
            longDescription={plan.description}
            cesSpecs={plan.cesSpecs}
            clickTrackingURL={plan.clickTrackingURL}
            insightPrice={plan.price.price}
            currency={plan.price.currency}
            disableNavLinks={disableNavLinks}
            image={{ url: plan.image }}
            addToCart={addToCart}
            showPrice={showPrice}
            categoryType={categoryType}
          />
        ))}

        <div className="c-product-tabs__show-more">
          {warranties?.length &&
            warranties?.length > limit &&
            renderViewMore(showFlag, setShowFlag)}
        </div>
      </div>
    );
  };

  const renderViewMore = (showFlag, setShowFlag) =>
    showFlag ? (
      <Button color="link" icon="remove" onClick={() => setShowFlag(false)}>
        {t('View less protection plans')}
      </Button>
    ) : (
      <Button color="link" icon="add" onClick={() => setShowFlag(true)}>
        {t('View more protection plans')}
      </Button>
    );

  return (
    <>
      {renderPlans(protection, true)}
      {renderPlans(thirdPartyProtection, false)}
    </>
  );
};

export default ProductDetailTabProtection;

ProductDetailTabProtection.propTypes = {
  limit: PropTypes.number,
  disableNavLinks: PropTypes.bool,
  protection: PropTypes.array,
  thirdPartyProtection: PropTypes.array,
  addToCart: PropTypes.func.isRequired,
};

ProductDetailTabProtection.defaultProps = {
  limit: 3,
  disableNavLinks: true,
  protection: [],
  thirdPartyProtection: [],
};
